import { api } from "../../lib/api";
export const createNewProject = async (partyNumber, createProjectRequest) => {
    const { data, headers } = await api.post(`/projects?partyNumber=${partyNumber}`, createProjectRequest);
    // add projectID to data from respone header if is not sent in body
    if (headers["projectId"] !== undefined || data.projectId === undefined) {
        data.projectId = headers["projectId"];
    }
    return { projectId: data.projectId };
};
export const getProjectDetails = async (projectId, partyNumber) => {
    const config = {
        params: {
            partyNumber
        }
    };
    const queryParams = new URLSearchParams(config.params).toString();
    const { data } = await api.get(`/projects/${projectId}${queryParams && "?" + queryParams}`);
    return data;
};
